<template>
    <ListenerMobileShell v-if="isListenerMobile" />
    <div v-else class="relative h-screen-index">
        <div class="flex md:pl-2">
            <Sidebar class="!hidden md:!block" />
            <div class="min-w-0 flex-1 px-2 md:py-2">
                <keep-alive max="18">
                    <router-view v-if="isRouteCacheable" :key="routeCacheKey"></router-view>
                </keep-alive>
                <router-view v-if="!isRouteCacheable" :key="routeCacheKey"></router-view>
            </div>
        </div>
        <div class="fixed bg-base-300/95 rounded-xl shadow-xl visible bottom-[65px] md:bottom-6 left-0 md:left-1/4 w-[95%] md:w-1/2 mx-[2.5%] md:mx-auto z-[19]">
            <Player />
        </div>
        <div class="drawer">
            <input id="showBar" type="checkbox" class="drawer-toggle" v-model="isShowSideBar" />
            <div class="drawer-content">
            </div>
            <div class="drawer-side z-10">
                <label for="showBar" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="p-4 min-h-full bg-base-100 text-base-content">
                    <Sidebar />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import Sidebar from '@/components/library/Sidebar'
    import Player from '@/views/library/player/Player'
    import ListenerMobileShell from '@/components/library/mobile/ListenerMobileShell.vue'
    export default {
        name: 'library',
        components: {
            Sidebar, Player, ListenerMobileShell
        },
        data() {
            return {
                isShowSideBar: false,
                viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1200
            }
        },
        computed: {
            ...mapGetters(['getIsSuperuser']),
            isListenerMobile() {
                return !this.getIsSuperuser && this.viewportWidth <= 768
            },
            isRouteCacheable() {
                return ['albums', 'artists', 'tracks', 'genres', 'genre', 'artist-tracks'].includes(this.$route.name)
            },
            routeCacheKey() {
                return this.$route.path.replace(/\/+$/, '')
            }
        },
        mounted() {
            window.addEventListener('resize', this.handleResize, { passive: true })
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize)
        },
        methods: {
            handleResize() {
                this.viewportWidth = window.innerWidth
            },
            showSideBar() {
                this.isShowSideBar = !this.isShowSideBar
            }
        }
    }
</script>
